/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CarIcon = ({ width = 24, height = 24, hidden = false, title = 'Car' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m33.291 17.288-.792-.79-3.46-8.074A4 4 0 0 0 25.362 6H10.638A4 4 0 0 0 6.96 8.424L3.5 16.5l-.793.793A2.412 2.412 0 0 0 2 19V33a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-5h24v5a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V18.996a2.412 2.412 0 0 0-.709-1.708ZM9.26 9.41a1.498 1.498 0 0 1 1.379-.909h14.724a1.498 1.498 0 0 1 1.38.91L29.565 16H6.434ZM8 25a3 3 0 1 1 3-3 3 3 0 0 1-3 3Zm20 0a3 3 0 1 1 3-3 3 3 0 0 1-3 3Z"
    />
  </svg>`;
};
